import React from "react";
import { Box, CircularProgress, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";

export function AtCircularProgress({ message }) {
    const { t } = useTranslation();
    return (
        <Box display="flex" justifyContent="center" padding={2}>
            <Box display="flex" flexDirection="column" alignItems="center">
                <CircularProgress title={t('text.loading')} />
                <Typography style={{ fontWeight: "bold", marginTop: 5 }}>
                    {message || t('text.loading')}
                </Typography>
            </Box>
        </Box>
    );
}
